// extracted by mini-css-extract-plugin
export default {"brandSecondary":"brand_secondary_button-module__brandSecondary---knI5"};